import * as THREE from 'three';

/** Radial alpha stops (0 centre .. 1 edge) for a white sprite. */
export type DiscStops = readonly (readonly [number, number])[];

/** A star: a bright centre and a short falloff. */
export const STAR_STOPS: DiscStops = [[0, 1], [0.3, 0.9], [1, 0]];
/** Dust and glow: a long, smooth tail with no visible edge. */
export const SOFT_STOPS: DiscStops = [[0, 1], [0.12, 0.55], [0.4, 0.2], [0.7, 0.05], [1, 0]];

/** A white sprite with a radial alpha gradient, drawn on a canvas so nothing needs loading. */
export function discTexture(stops: DiscStops, size = 64): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d')!;
  const h = size / 2;
  const grd = g.createRadialGradient(h, h, 0, h, h, h);
  for (const [at, a] of stops) grd.addColorStop(at, `rgba(255,255,255,${a})`);
  g.fillStyle = grd;
  g.fillRect(0, 0, size, size);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}
